import { initSentry } from '@imt/vue-toolbox/src/plugins/sentry';
import * as Sentry from '@sentry/vue';
import Vue from 'vue';

initSentry({
    Vue,
    dsn: 'https://d7483f8b639e4ee6b2d5333abf710329@o527262.ingest.sentry.io/5658863',
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.vueIntegration({
            tracingOptions: {
                trackComponents: true,
            },
        }),
    ],
    tracesSampleRate: 1.0,
});
